import { Dialog, DialogContent, DialogTitle } from '@/components/Dialog';
import { useDimensions } from '@/hooks/useDimensions';
import { cn } from '@/utils';
import { DialogDescription } from '@radix-ui/react-dialog';
import { useCallback, useMemo } from 'react';
import { create } from 'zustand';
import InstrumentsPreview from '../components/R3ImageArea/InstrumentsPreview';

interface R3ImageInstrumentsDialogStore {
  open: boolean;
  disabled: boolean;
  setOpen: (open: boolean) => void;
  setDisabled: (disabled: boolean) => void;
}

const useR3ImageInstrumentsDialogStore = create<R3ImageInstrumentsDialogStore>((set) => ({
  open: false,
  disabled: false,
  setOpen: (open) => set({ open }),
  setDisabled: (disabled) => set({ disabled }),
}));

export const useInstrumentsDialog = () => {
  const { open, disabled, setOpen, setDisabled } = useR3ImageInstrumentsDialogStore();

  const { isMobileOrPad, isIPhoneSEorSmaller } = useDimensions();

  const show = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const hide = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const DialogComponent = useMemo(
    () =>
      function R3ImageDialog() {
        return (
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent
              className={cn(
                'shadow-none bg-transparent fixed left-[50%] top-[50%] z-50 grid w-full translate-x-[-50%] translate-y-[-50%] gap-4 p-6  duration-200 text-white data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg',
                isMobileOrPad && 'p-2 mt-24',
                isIPhoneSEorSmaller && 'scale-[0.9] p-2 mt-24',
              )}
              style={{
                maxWidth: 'max-content',
              }}
            >
              <InstrumentsPreview hide={hide} />
            </DialogContent>
            <DialogDescription />
          </Dialog>
        );
      },
    [open, disabled, isIPhoneSEorSmaller],
  );

  return {
    open,
    disabled,
    show,
    hide,
    setDisabled,
    DialogComponent,
  };
};
